<ziro-collapsible-section-card
  data-automation="auto-attendants-menu-buttons"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
  [title]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destination.buttons.label'"
>
  @for (btn of configuredButtons; track btn.key; let isLast = $last) {
    <div
      [ngClass]="{
        'call-flow-buttons__row': !isLast,
        'call-flow-buttons__row--expanded': isExpanded(btn.key),
        'call-flow-buttons__row--empty': !btn.destination,
      }"
      [attr.data-automation]="'menu-button-row-' + btn.key"
    >
      <div
        class="call-flow-buttons__row-summary d-flex align-items-center gap-3 px-3 py-2"
        (click)="toggleRow(btn.key)"
        [attr.data-automation]="'menu-button-row-summary-' + btn.key"
      >
        <div class="call-flow-buttons__key" [attr.data-automation]="'menu-button-key-' + btn.key">{{ btn.key }}</div>

        <div class="call-flow-buttons__info flex-grow-1 min-w-0">
          <div class="call-flow-buttons__type" [attr.data-automation]="'menu-button-type-' + btn.key">
            <i class="{{ btn.icon }} pe-1"></i>
            {{ btn.label | translate }}
          </div>
          <div
            class="call-flow-buttons__name text-truncate"
            [attr.data-automation]="'menu-button-destination-' + btn.key"
          >
            {{
              btn.action === AutoAttendantButtonAction.ANNOUNCEMENT_AUDIO_FILE && btn.audioInfo?.fileName
                ? btn.audioInfo?.fileName
                : (btn.subLabel ?? btn.destination | translate)
            }}
          </div>
        </div>

        <div class="call-flow-buttons__actions d-flex align-items-center gap-2 flex-shrink-0">
          @if (hasError(btn.key)) {
            <span
              [class]="ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'"
              [attr.data-automation]="'menu-button-error-icon-' + btn.key"
            ></span>
          }
          <i class="{{ isExpanded(btn.key) ? ZiroIcons.MENU_EXPANDED : ZiroIcons.MENU_MINIMIZED }}"></i>
        </div>
      </div>

      @if (isExpanded(btn.key)) {
        <div
          class="call-flow-buttons__editor border-top px-3 py-3 bg-light"
          [class.call-flow-buttons__editor--last]="isLast && unusedKeys.length === 0"
          [attr.data-automation]="'menu-button-editor-' + btn.key"
        >
          <ziro-menu-button-form
            [tenantId]="tenantId()"
            [buttonKey]="btn.key"
            [initialButton]="btn"
            (ziroFormsUpdate$)="onRowUpdate($event)"
          ></ziro-menu-button-form>
        </div>
      }
    </div>
  }

  @if (unusedKeys.length > 0) {
    <div
      class="call-flow-buttons__unused"
      data-automation="menu-buttons-unused-section"
      [ngClass]="{ 'border-top': configuredButtons.length !== 0 }"
    >
      <div
        class="call-flow-buttons__unused-header d-flex align-items-center justify-content-between px-3 py-2"
        [class.call-flow-buttons__unused-header--expanded]="unusedOpen()"
        (click)="toggleUnused()"
        data-automation="menu-buttons-unused-toggle"
      >
        <span class="d-flex align-items-center gap-2">
          {{
            'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destination.buttons.unused_buttons'
              | translate
          }}
          <span
            class="call-flow-buttons__unused-count badge rounded-pill text-bg-secondary"
            data-automation="menu-buttons-unused-count"
          >
            {{ unusedKeys.length }}
          </span>
          @if (hasAnyUnusedError) {
            <span
              [class]="ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger ms-1'"
              data-automation="menu-buttons-unused-error-icon"
            ></span>
          }
        </span>

        <span class="call-flow-buttons__unused-toggle">
          {{
            unusedOpen()
              ? ('tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destination.buttons.unused_buttons.hide.label'
                | translate)
              : ('tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destination.buttons.unused_buttons.show.label'
                | translate)
          }}
        </span>
      </div>

      @if (unusedOpen()) {
        @for (item of unusedKeys; track item.key; let isLast = $last) {
          <div
            class="call-flow-buttons__row"
            [ngClass]="{
              'call-flow-buttons__row': !isLast,
              'call-flow-buttons__row--expanded': isExpanded(item.key),
              'call-flow-buttons__row--empty': true,
            }"
            [attr.data-automation]="'menu-button-unused-row-' + item.key"
          >
            <div
              class="call-flow-buttons__row-summary d-flex align-items-center gap-2 px-3 py-2"
              (click)="toggleRow(item.key)"
              [attr.data-automation]="'menu-button-unused-row-summary-' + item.key"
            >
              <div class="call-flow-buttons__key call-flow-buttons__key--unused">{{ item.key }}</div>
              <span class="text-muted small fst-italic flex-grow-1">
                {{
                  'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destination.buttons.not_configured'
                    | translate
                }}
              </span>
              @if (hasError(item.key)) {
                <span
                  [class]="
                    ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'
                  "
                  [attr.data-automation]="'menu-button-error-icon-' + item.key"
                ></span>
              }
              <i class="{{ isExpanded(item.key) ? ZiroIcons.MENU_EXPANDED : ZiroIcons.MENU_MINIMIZED }}"></i>
            </div>

            @if (isExpanded(item.key)) {
              <div
                class="call-flow-buttons__editor border-top px-3 py-3 bg-light"
                [class.call-flow-buttons__editor--last]="isLast"
                [attr.data-automation]="'menu-button-unused-editor-' + item.key"
              >
                <ziro-menu-button-form
                  [tenantId]="tenantId()"
                  [buttonKey]="item.key"
                  [initialButton]="null"
                  (ziroFormsUpdate$)="onRowUpdate($event)"
                ></ziro-menu-button-form>
              </div>
            }
          </div>
        }
      }
    </div>
  }
</ziro-collapsible-section-card>
